
export const MaliciousTypes = [
  "Malware",
  "Phishing",
  "Defacement",
  "Malware",
  "Phishing",
  "Defacement",
];
